(() => {
  'use strict';

  const init = () => {
    const gate = document.getElementById('ep-login-gate');
    if (!document.body.classList.contains('ep-gate-locked') || !gate || gate.dataset.epGateInitialized) return;

    const form = gate.querySelector('[data-ep-gate-form]');
    const confirmation = gate.querySelector('#ep-gate-confirm');
    const submit = form?.querySelector('.ep-gate-submit');
    if (!form || !confirmation || !submit) return;

    gate.dataset.epGateInitialized = 'true';
    const locked = () => document.body.classList.contains('ep-gate-locked');
    const sync = () => {
      submit.disabled = !confirmation.checked;
    };

    confirmation.addEventListener('input', sync);
    confirmation.addEventListener('change', sync);
    form.addEventListener('reset', () => window.setTimeout(sync, 0));
    window.addEventListener('pageshow', () => {
      sync();
      window.requestAnimationFrame(sync);
      window.setTimeout(sync, 0);
    });
    form.addEventListener('submit', (event) => {
      if (!confirmation.checked) {
        event.preventDefault();
        confirmation.reportValidity();
        confirmation.focus();
      }
    });

    const selector = 'a[href], area[href], button, input:not([type="hidden"]), select, textarea, iframe, summary, audio[controls], video[controls], [contenteditable="true"], [tabindex]';
    const focusable = (element) => {
      if (element.tabIndex < 0 || element.matches(':disabled') || element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
      const style = window.getComputedStyle(element);
      return style.visibility !== 'hidden' && style.visibility !== 'collapse' && element.getClientRects().length > 0;
    };

    gate.addEventListener('keydown', (event) => {
      if (!locked()) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (event.key !== 'Tab' || event.altKey || event.ctrlKey || event.metaKey) return;
      const all = [...document.querySelectorAll(selector)].filter(focusable);
      if (all.some((element) => !gate.contains(element))) return;
      const first = all[0];
      const last = all[all.length - 1];
      if (!first) {
        event.preventDefault();
        gate.focus();
      } else if (event.shiftKey && (document.activeElement === first || !all.includes(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    sync();
    window.requestAnimationFrame(sync);
    if (document.activeElement === document.body || document.activeElement === document.documentElement) {
      gate.focus({ preventScroll: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
